<ng-container *ngIf="created">
  <div *ngIf="getRetomar();else loadData">
    <h1 class="titulo-principal carga-data">Si ya iniciaste un proceso de <br> contratación retoma aquí.</h1>
    <p class="descripcion-principal">Ingresa tus datos para continuar la solicitud</p>
  </div>
  <ng-template #loadData>
    <h1 class="titulo-principal carga-data">Bienvenidos al proceso de <br> incorporación Transbank.</h1>
    <p class="descripcion-principal">Comencemos con el RUT y así agilizaremos la carga de tus datos.</p>
  </ng-template>
  <div class="card-principal">
    <form [formGroup]="dataPasoUno">
      <div class="row">
        <div class="col-md-12 seleccion-flujo">
          <mat-radio-group formControlName="seleccionFlujo">
            <mat-radio-button tabindex="1" name="personaNatural" value="personaNatural" class="mr-63">
              Persona natural
            </mat-radio-button>
            <mat-radio-button name="personaJuridica" value="personaJuridica" class="radio-persona-juridica" (click)="fixForm()">Persona
              jurídica</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="persona-natural" *ngIf="dataPasoUno.get('seleccionFlujo').value==='personaNatural'">
       <app-persona-natural (nextStep)="onNextStep($event)"></app-persona-natural>
      </div>
      <div class="mt-36" *ngIf="dataPasoUno.get('seleccionFlujo').value==='personaJuridica'">
        <app-persona-juridica></app-persona-juridica>
      </div>
    </form>
  </div>
</ng-container>



